var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinimize = function SvgMinimize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.767 15.554a2.68 2.68 0 0 1 2.677 2.677v3.118a.6.6 0 0 1-1.2 0V18.23a1.48 1.48 0 0 0-1.477-1.478H2.649a.6.6 0 1 1 0-1.2zm15.585 0a.6.6 0 0 1 0 1.199h-3.118a1.48 1.48 0 0 0-1.478 1.478v3.118a.6.6 0 0 1-1.2 0V18.23a2.68 2.68 0 0 1 2.678-2.677zM7.845 2.047a.6.6 0 0 1 .6.6v3.117A2.68 2.68 0 0 1 5.766 8.44H2.649a.6.6 0 0 1 0-1.2h3.118a1.48 1.48 0 0 0 1.477-1.477V2.646a.6.6 0 0 1 .6-.6m8.311 0a.6.6 0 0 1 .6.6v3.117a1.48 1.48 0 0 0 1.478 1.477h3.118a.6.6 0 0 1 0 1.2h-3.118a2.68 2.68 0 0 1-2.677-2.677V2.646a.6.6 0 0 1 .6-.6"
  })));
};
export default SvgMinimize;